import React from "react";
import { motion } from "framer-motion";
import { RiLinkedinFill } from "react-icons/ri";
import { FaGithub } from "react-icons/fa";
import { ImProfile } from "react-icons/im";
import { images } from "../constants";

const SocialMedia = () => (
  <div className="app__social">
    {[
      { icon: <RiLinkedinFill />, link: "https://www.linkedin.com/in/robinmwinters" },
      { icon: <FaGithub />, link: "http://github.com/robinucar" },
      { icon: <ImProfile />, link: images.resume, download: true },
    ].map((item, index) => (
      <motion.div
      key={index}
      initial={{ scale: 1 }}
      animate={{
        scale: [1, 1.5, 1], // much more breathing now
        filter: [
          'drop-shadow(0 0 0px rgba(0,0,0,1))',   // PURE BLACK
          'drop-shadow(0 0 20px rgba(0,0,0,1))',  // Stronger bigger glow
          'drop-shadow(0 0 0px rgba(0,0,0,1))',
        ],
      }}
      transition={{
        duration: 5,
        repeat: Infinity,
        repeatType: 'loop',
        ease: 'easeInOut',
        times: [0, 0.5, 1],
      }}
    >
      <a
        href={item.link}
        target="_blank"
        rel="noreferrer"
        {...(item.download ? { download: true } : {})}
      >
        {item.icon}
      </a>
    </motion.div>
    
    ))}
  </div>
);

export default SocialMedia;
